module.exports = __webpack_public_path__ + "static/media/indik-8.26aa2f15.png";